import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { getDocs, collection, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/Firebase";
import { updateDoc, doc, deleteDoc } from "firebase/firestore";

import { Toast } from "primereact/toast";

const EditModal = (props) => {
  const show = props.showEdit;
  const setShow = props.setShowEdit;
  const toast = useRef(null);
  const setCounter = props.setCounter;
  const counter = props.counter;

  const event = props.editData ? props.editData : "";
  // console.table(event)
  const [title, setTitle] = useState(event["title"] || "");
  const [start, setStart] = useState(event["start"] || "");
  const [end, setEnd] = useState(event["end"] || "");
  const [desc, setDesc] = useState(event["desc"] || "");
  const [color, setColor] = useState(event["color"] || "");
  const [id, setId] = useState(event["id"] || "");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setTitle(event["title"]);
    setStart(event["start"]);
    setEnd(event["end"]);
    setDesc(event["desc"] || "");
    setColor(event["color"] || "");
    setId(event["id"]);
  }, [event]);

  const resetItems = () => {
    setTitle("");
    setStart("");
    setEnd("");
    setDesc("");
    setColor("");
    setId("");
  };

  const update = async () => {
    setLoading(true);
    try {
      const docRef = doc(db, "events", id);
      const updateTimestamp = await updateDoc(docRef, {
        title: title.trim(),
        start: start,
        end: end,
        desc: desc.trim(),
        color: color,
      });
      toast.current.show({
        severity: "success",
        summary: "success",
        detail: "Event has been successfully updated.",
      });
      setCounter(counter + 1);
      setShow(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating document:");
    }
  };

  const deleteEvent = async () => {
    setLoading(true);
    var answer = window.confirm(
      "Are You sure you want to Delete: " + title + " ?"
    );
    if (answer) {
      try {
        // Create the document reference
        const docRef = doc(db, "events", id);

        // Delete the document
        await deleteDoc(docRef);

        toast.current.show({
          severity: "danger",
          summary: "danger",
          detail: "Event has been successfully Deleted.",
        });
        setCounter(counter + 1);
        setShow(false);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error Deleting document:");
      }
    }
    setLoading(false);
  };
  return (
    <>
      <Toast ref={toast} />
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          resetItems();
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="bg-success">
          <Modal.Title className="text-white">Edit Task </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formTitle">
              <Form.Label className="text-success">
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                onChange={(e) => setTitle(e.target.value)}
                value={title}
              />
            </Form.Group>
            <Form.Group controlId="formStart" className="p-1">
              <Form.Label className="text-success">
                Start<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="datetime-local"
                value={start}
                onChange={(e) => setStart(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEnds" className="p-1">
              <Form.Label className="text-success">
                Ends<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="datetime-local"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formDesc" className="p-1">
              <Form.Label className="text-success">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
              />
            </Form.Group>
            <Form.Group controlId="formColor" className="p-1">
              <Form.Label className="text-success">Color</Form.Label>
              <Form.Control
                type="color"
                onChange={(e) => setColor(e.target.value)}
                value={color}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="danger" onClick={deleteEvent}>
            Delete Event
          </Button>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          {!loading && (
            <Button variant="success" onClick={update}>
              Update
            </Button>
          )}
          {loading && (
            <Button variant="success" disabled>
              Updating...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditModal;
